export default "__VITE_ASSET__Do8$vmk9__"